<template>
  <div class="w-100 transition">
    <GenericReport
      title="Relatório de Recebimento de Materais Médicos"
      :route="route"
      :topFilters="topFilters"
      :sideFilters="sideFilters"
      :fields="fields"
      tipoRelatorio="relatorioMateriaisMedicos"
    />
  </div>
</template>

<script>
import moment from 'moment';

import GenericReport from '@/components/Table/GenericReport';

export default {
  name: 'relatorioEntradasOpme',
  components: {
    GenericReport,
  },
  data() {
    return {
      route: 'report/entradas',
      topFilters: {
        id_unidade: {
          type: 'genericSelect',
          route: 'unidade',
          firstOption: {
            value: null,
            label: 'Unidade Destino',
          },
        },
        id_tipo_material: {
          type: 'select',
          firstOption: {
            value: 2,
            label: 'Material Médico',
            disabled: true,
          },
          defaultValue: 2,
          options: [
            { value: 2, text: '', disabled: true },
          ],
        },
        date: {
          type: 'rangeDate',
          defaultInitDate: moment().subtract(7, 'days'),
          defaultEndDate: moment(),
        },
      },
      sideFilters: {
        id: {
          type: 'input',
          label: 'ID',
          filterTeclas: true,
        },
        descricao: {
          type: 'input',
          label: 'Descrição',
        },
        id_medico: {
          type: 'genericSelect',
          label: 'Médico',
          route: 'medico',
        },
      },
      fields: [
        {
          label: 'Tipo de material',
          key: 'tipoMaterial',
          formatter: (value) => value && value.nome,
        },
        {
          label: 'ID',
          key: 'shownId',
        },
        {
          label: 'Descrição',
          key: 'descricao',
        },
        {
          label: 'Peças',
          key: 'quantidade_itens',
        },
        {
          label: 'Médico',
          key: 'medico',
          formatter: (value) => value && value.nome,
        },
        {
          label: 'Unidade Destino',
          key: 'unidadePatrimonio',
          formatter: (value) => value && value.nome,
        },
        {
          label: 'Data/Hora',
          key: 'createdAt',
          formatter: (value) => moment(value).format('DD/MM/YY HH:mm'),
        },
        {
          label: 'Usuário',
          key: 'usuario',
          formatter: (value) => value && value.nome,
        },
        {
          label: 'Devolução',
          key: 'devolucao',
          formatter: (value) => (value ? moment(value).format('DD/MM/YY HH:mm') : '-'),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
$primary-color-50: #209f85;

.paginador {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.transition {
  transition: 0.3s ease-in-out;
}

#report h2 {
  margin-bottom: 30px;
}

#report table {
  background-color: #FFF;
}

#report table thead th {
  color: #7E829F;
  padding-bottom: 50px;
  font-weight: 900;
}

</style>
